/**
 * Main entry point for StarNexus Platform
 * Following AWS-UI-Examples patterns
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// I18n setup
import { I18nProvider, enMessages } from './i18n';

// Initialize global styles (must be imported before App)
import './common/apply-mode';

// Custom base styles
import './styles/base.css';

import App from './App';
import { ErrorBoundary } from './components/starnexus/common/ErrorBoundary';

try {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <I18nProvider locale="en" messages={[enMessages]}>
        <BrowserRouter>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </BrowserRouter>
      </I18nProvider>
    </React.StrictMode>
  );
} catch (error) {
  console.error('[main.tsx] Failed to render app:', error);
  // Build the fallback DOM imperatively with textContent so an error message that happens
  // to contain HTML (e.g. an exception thrown from JSX with an attacker-influenced string)
  // cannot smuggle script/markup into the page. The earlier innerHTML template was an XSS sink.
  const root = document.getElementById('root')!;
  root.replaceChildren();
  const wrapper = document.createElement('div');
  wrapper.style.cssText = 'padding: 20px; font-family: sans-serif;';
  const h1 = document.createElement('h1');
  h1.textContent = 'Failed to load application';
  const p = document.createElement('p');
  p.textContent = 'Error: ' + (error instanceof Error ? error.message : 'Unknown error');
  const pre = document.createElement('pre');
  pre.style.cssText = 'background: #f4f4f4; padding: 10px; overflow: auto;';
  pre.textContent = error instanceof Error ? error.stack || '' : '';
  wrapper.append(h1, p, pre);
  root.append(wrapper);
}
